import {decorate, inject, injectable} from '@yosmanyga/di'
import {AbstractSecureStorage, SecureStorage} from '@yosmanyga/abstract-secure-storage'
import {Dispatcher} from './Dispatcher'

class DeviceManager {
    private device!: string | null

    constructor(
        private secureStorage: SecureStorage,
        private dispatcher: Dispatcher
    ) {
    }

    load = async () => {
        const device = await this.secureStorage.get('device')

        this.device = device || null
    }

    get = (): string | null => {
        if (typeof this.device === 'undefined') {
            throw new Error();
        }

        return this.device
    }

    save = async (
        device: string
    ) => {
        await this.secureStorage.set('device', device)

        this.device = device

        // this.dispatcher.retrieve<(device: string) => void>('device_saved').map(service => service(device))
    }

    delete = async () => {
        await this.secureStorage.delete('device')

        this.device = null

        this.dispatcher.retrieve<() => void>('device_deleted').map(service => service())
    }
}

decorate(injectable(), DeviceManager)
decorate(inject(AbstractSecureStorage), DeviceManager, 0)
decorate(inject(Dispatcher), DeviceManager, 1)

export {
    DeviceManager
}
